import { FileDown } from 'lucide-react';
import SearchFilter from './SearchFilter';
import InvoiceHistoryTable from './InvoiceHistoryTable';
import { toast } from 'sonner';

function InvoicesTab({
  invoices,
  filteredInvoices,
  driveConnected,
  onSearch,
  onFilterChange,
  onEdit,
  onDownload,
  onDownloadFormat,
  onExportToDrive,
  onDelete,
  onShowExportModal,
  onMarkPaid,
  onMarkUnpaid
}) {
  return (
    <>
      {/* Search & Filter */}
      <div className="mb-4">
        <SearchFilter 
          onSearch={onSearch} 
          onFilterChange={onFilterChange}
          onAISearch={(query) => {
            toast.info('Opening AI Chat with your query...');
          }}
        />
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-4 sm:mb-6">
        <div className="flex items-center space-x-2">
          <span className="text-sm text-slate-600 dark:text-slate-400">
            Showing {filteredInvoices.length} of {invoices.length} invoices
          </span>
        </div>
        <div className="flex items-center space-x-2 sm:space-x-3">
          {invoices.length > 0 && (
            <button
              onClick={onShowExportModal}
              className="px-3 sm:px-4 py-2 bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm hover:shadow-md transition-all font-medium rounded-lg flex items-center space-x-2 text-xs sm:text-sm"
              data-testid="export-all-button"
            >
              <FileDown className="w-4 h-4" />
              <span>Export</span>
            </button>
          )}
        </div>
      </div>

      <InvoiceHistoryTable
        invoices={filteredInvoices}
        onEdit={onEdit}
        onDownload={onDownload}
        onDownloadFormat={onDownloadFormat}
        onExportToDrive={onExportToDrive}
        onDelete={onDelete}
        onMarkPaid={onMarkPaid}
        onMarkUnpaid={onMarkUnpaid}
      />
    </>
  );
}

export default InvoicesTab;
